import { render, staticRenderFns } from "./PieOtherChart.vue?vue&type=template&id=d8ee5ca2&"
import script from "./PieOtherChart.vue?vue&type=script&lang=js&"
export * from "./PieOtherChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports